import React, { useEffect, useMemo, useRef, useState } from 'react';
import { List, ListItemButton } from '@mui/material';

import { useAppSelector } from '../../../../../stores/hook';
import translations from '../../../../../text/get-started-translations.json';
import language from '../../../../../utils/LanguageSettings';
import cx from 'classnames';

import styles from './FilterModal.module.scss'
import { IChannels, ILibraries } from '../../../types';
import ChannelDemandPanel from '../../components/ChannelDemandPanel/ChannelDemandPanel';
import closeImage from '../../../../../images/icon/icon-close.svg';

interface FilterModalProps {
    channels: any[];
    libraries: any[];
    onClose?: () => void
}

type TabItem = {
  key: string,
  value: string,
}

const FilterModal: React.FC<FilterModalProps> = ({channels,libraries, onClose}) => {
  const isShowFitlerPopUp = useAppSelector((state) => state.getStarted.isShowFitlerPopUp)
  const pageTranslations = translations[language]; // Select the correct translations
  const [activeKey, setActiveKey] = useState(0);
  const [open, setOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(document.body.clientWidth);
  const [filteredChannels, setFilteredChannels] = useState<IChannels[]>([]);
  const [filteredLibraries, setFilteredLibraries] = useState<ILibraries[]>([]);
  const [isShowFilterAlter, setIsShowFilterAlter] = useState<boolean>(false);
  const listenerFilterRef = useRef(null);

  const channelTab: TabItem[] = useMemo(() => {
    return [{
      key: 'All',
      value: pageTranslations.All
      },
      {
        key: "Sports",
        value: pageTranslations.Sports
      },
      {
        key:"Movies/Drama",
        value: pageTranslations.Movie
      },
      { 
        key: "Entertainment",
        value: pageTranslations.Entertainment
      },
      {
        key: "Asian Entertainment",
        value: pageTranslations.AsianEntertainment
      },
      { key: "Western Entertainment",
        value: pageTranslations.WesternEntertainment
      },
      {
        key: "Travel",
        value: pageTranslations.Travel
      },
      {
        key:"Knowledge",
        value: pageTranslations.Knowledge
      },
      {
        key:"Kids/Learn",
        value: pageTranslations.Kids
      },
      {
        key: "Infotainment",
        value: pageTranslations.Infotainment
      },
      {
        key: "Foreign Language", 
        value: pageTranslations.ForeignLanguage
      }
    ];
  }, [pageTranslations])


  useEffect(() => {
    const setClientWidth = () => {
      setWindowWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', setClientWidth)
    return () => {
      window.removeEventListener('resize', setClientWidth)
    }
  }, []);
  useEffect(()=>{
    if(isShowFitlerPopUp){
      setIsShowFilterAlter(true);
    }
  },[isShowFitlerPopUp])

  useEffect(() => {
    // setInitChannel/library data
    setFilteredChannels(channels);
    setFilteredLibraries(libraries);
  }, [channels, libraries])

  useEffect(() => {
        const handleFilterLiener = (event: any) => {
          const targetDiv = document.getElementById('filter-wrapper');
          if (targetDiv && !targetDiv.contains(event.target)) {
            closeFilter();
          }
        };
    
        listenerFilterRef.current = handleFilterLiener;
    
        if (isShowFilterAlter) {
          document.addEventListener('click', handleFilterLiener);
        } else {
          document.removeEventListener('click', handleFilterLiener);
        }
    
        return () => {
          document.removeEventListener('click', listenerFilterRef.current);
        };
      }, [isShowFilterAlter]);
    
  const closeFilter = () => {
    setIsShowFilterAlter(false);
    onClose && onClose()
  }

  const onTabClick = (tabName: string, tabIndex: number) => {
    console.log(tabIndex);
    console.log(tabName);
    setActiveKey(tabIndex)
    if(Array.isArray(channels)) {
      const filteredChannels = tabName.toUpperCase() === 'ALL' ? channels : channels.filter((item, index) => {
        if (item?.attributes?.type?.toUpperCase() === tabName.toUpperCase()) {
          return true;
        } else {
          return false;
        }
        // return null;
      })
      console.log('filteredChannels: ', filteredChannels)
      setFilteredChannels(filteredChannels);
    }
    if (Array.isArray(libraries)) {
      const filteredLibraries = tabName.toUpperCase() === 'ALL' ? libraries : libraries.filter((item, index) => {
        if (item?.attributes?.type?.toUpperCase() === tabName.toUpperCase()) {
          return true;
        } else {
          return false;
        }

      })
      console.log('filteredLibraries: ', filteredLibraries);
      setFilteredLibraries(filteredLibraries);
    }
  }
  const checkIfListNotNull = (tab: TabItem, list: IChannels[] | ILibraries[], index: number) => {
    let filterList = [];
    if (list.length > 0) {
      filterList = list.filter((item) => {
        if(item?.attributes?.type?.toUpperCase() === tab.key.toUpperCase()) {
          return true;
        }
      })
    }
    return filterList.length > 0 ?  true : false;
  };
  const renderTabs = () => {
    if (windowWidth > 767) {
      return channelTab.map((tab: TabItem, index) => {
        let isChannelListNotNull = true, isLibraryListNotNull = true;
        if (tab.key.toUpperCase() === 'ALL') {
          isChannelListNotNull = channels.length > 0 ? true : false;
          isLibraryListNotNull = libraries.length > 0 ? true : false;
        } else {
          isChannelListNotNull = checkIfListNotNull(tab, channels, index);
          isLibraryListNotNull = checkIfListNotNull(tab, libraries, index);
        }
        if (isChannelListNotNull || isLibraryListNotNull) {
          return (<button 
                    className={cx({[styles.active]: index === activeKey})}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => onTabClick(tab.key, index)}
                    key={index}
                  >{tab.value}</button>)
        } else {
          return null
        }
      })
     } else {
      const handleListItemClick = (tabName: string, index: number) => {
        onTabClick(tabName, index);
        setOpen(!open);
      }
      const handleSelectClick = (event: React.MouseEvent) => {
        setOpen(!open);
      }

      return (
          <div>
            <div
              className={cx(styles.mobileSelect, {[styles.mobileActive]: open})}
              onClick={handleSelectClick}
            >{channelTab[activeKey].value}</div>
            <div style={{display: open ? 'block' : 'none', height: 'auto'}} className={styles['channel-opions-list']}>
              <List
                sx={{
                  padding: '0',
                }}
              >
                {channelTab.map((tab, index) => {
                  let isChannelListNotNull = true, isLibraryListNotNull = true;
                  if (tab.key.toUpperCase() === 'ALL') {
                    isChannelListNotNull = channels.length > 0 ? true : false;
                    isLibraryListNotNull = libraries.length > 0 ? true : false;
                  } else {
                    isChannelListNotNull = checkIfListNotNull(tab, channels, index);
                    isLibraryListNotNull = checkIfListNotNull(tab, libraries, index)
                  }
                  if (isChannelListNotNull || isLibraryListNotNull) {
                    return (
                    <ListItemButton
                      selected={activeKey === index}
                      sx={{
                        padding: '0',
                        borderTop: '1px solid #d8d8d8',
                        '&.Mui-selected': {
                          backgroundColor:'#EF9528',
                          color: '#ffffff',
                          pointerEvents: 'none',
                          '&:hover': {
                            backgroundColor:'#EF9528',
                            color: '#ffffff',
                          }
                        },
                        '&:hover': {
                          backgroundColor: 'transparent'
                        }
                      }}
                      key={index}
                      onClick={() => handleListItemClick(tab.key, index)}
                    >
                      <button style={{textAlign: 'center', width: '100%'}}>{tab.value}</button>
                    </ListItemButton>
                  )
                  } else {
                    return null
                  }
                  
                })}
              </List>
            </div>
          </div>
        
        )
      }
    }
    
    return (
      <>  
        <div className={styles.filterModal} style={{display: !isShowFitlerPopUp ? 'none' : ''}}>
            <div className={styles["modal-dialog"]}>
              <div className={styles["modal-content-wrapper"]}>
                <div className={styles["close-wrap"]}>
                    <div className={styles["close-btn"]}>
                      <button className="close-modal" onClick={() => closeFilter()}>
                        {pageTranslations.Close} 
                      <img src={closeImage} alt="Close icon" />
                      </button>
                    </div>
                </div>
    
                <div id="filter-wrapper" className={styles["filter-channels-wrapper"]}>
                  <div className={styles["filter-channels-head"]}>
                    <h2>{pageTranslations.SeePlans}</h2>
                    <div className={styles["channel-options"]}>
                      { renderTabs()}
                    </div>
                  </div>
                    {
                      filteredLibraries.length > 0 &&
                      <ChannelDemandPanel key='library' title={pageTranslations.OnDemandCatalogs2} list={filteredLibraries} type='library' />
                    }
                    {
                      filteredChannels.length > 0 && 
                      <ChannelDemandPanel key='channel' title={pageTranslations.LiveChannels} list={filteredChannels} type='channel' />
                    }
                   
                </div>
                
              </div>
        
            </div>
        
        </div>
</>
    );
}
export default FilterModal;